import { IconButton, useMediaQuery } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useAuthuser } from '../../hooks/useAuthuser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router';

export default function QRCodeScannerButton() {
    const history = useHistory();
    const { permissions } = useAuthuser();
    const isMobileOrTablet = useMediaQuery('(max-width:900px)');

    const userPermissions = useMemo(
        () => ({
            inlineInspection: permissions.some(
                (p) => p.name === 'inline_quality_inspection_add',
            ),
            processAssignment: permissions.some(
                (p) => p.name === 'device_processes_supervise_access',
            ),
            editMachine: permissions.some((p) => p.name === 'machine_access'),
        }),
        [permissions],
    );

    const isQrButtonVisible = useMemo(() => {
        const permissionCount =
            Object.values(userPermissions).filter(Boolean).length;
        return permissionCount > 0 && isMobileOrTablet;
    }, [isMobileOrTablet, userPermissions]);

    const handleQrCodeButtonClick = () => {
        history.push('/qr-scanner');
    };
    return (
        <>
            {isQrButtonVisible && (
                <IconButton className='p-2' size='small'  >
                    <FontAwesomeIcon icon={faQrcode} color='white' onClick={()=>handleQrCodeButtonClick()}/>
                </IconButton>
            )}
        </>
    );
}
